import { createRouter, createWebHashHistory } from 'vue-router';
import routes from './routes';
import { useUserStore} from 'd3components';
import { exChangeMenuToRouter } from './dynamic'; //导入动态路由生成函数
// const isNative = Capacitor.isNativePlatform();
// const history = isNative
//   ? createWebHashHistory()
//   : createWebHistory(import.meta.env.BASE_URL);

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes,
});

// 动态路由管理
let dynamicRoutesAdded = false;
// 添加动态路由的函数
export const addDynamicRoutes = async (force = false) => {
  if (force) dynamicRoutesAdded = false;
  if (dynamicRoutesAdded) return;
  try {
    const userStore = useUserStore();
    // console.log('console.log(userStore.routerData)', userStore.routerData)
    const menuSource = Array.isArray((userStore as any).routerData) ? (userStore as any).routerData : [];
    if (menuSource.length > 0) {
      // console.log('111resetMenuToRouter', menuSource)
      exChangeMenuToRouter(userStore, router);
      dynamicRoutesAdded = true;
      // console.log('动态路由添加成功');
    } else {
      console.warn('菜单数据为空，跳过动态路由添加');
    }
  } catch (error) {
    console.error('添加动态路由失败:', error);
    throw error; // 重新抛出错误，让调用方处理
  }
};
// 重置动态路由的函数
export const resetDynamicRoutes = () => {
  dynamicRoutesAdded = false;
  // console.log('动态路由已重置');
};

export default router;
